'use client'

import { useAuth } from '@clerk/nextjs'
import { usePathname, useSearchParams } from 'next/navigation'
import Button from '@shared/components/Button/Button'
import { KeyRoundIcon } from 'lucide-react'

export function SignedIn({ children }: { children: React.ReactNode }) {
  const auth = useAuth()

  if (!auth.isLoaded) return null
  if (!auth.isSignedIn) return null

  return <div className='fade-in'>{children}</div>
}

export function SignedOut({ children }: { children: React.ReactNode }) {
  const auth = useAuth()

  if (!auth.isLoaded) return null
  if (auth.isSignedIn) return null

  return <div className='fade-in'>{children}</div>
}

/**
 * Builds a `/login?redirect_url=...` href that sends users through the
 * fallback login page, which calls Clerk's `buildSignInUrl()` to perform the
 * satellite-domain session sync before redirecting them back here.
 */
export function useLoginHref() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const query = searchParams.toString()
  const redirectUrl = query ? `${pathname}?${query}` : pathname
  return `/login?redirect_url=${encodeURIComponent(redirectUrl)}`
}

export function SignInButton() {
  const href = useLoginHref()

  return (
    <Button title='Anmelden' size='small' circular href={href} variant='brand'>
      Login <KeyRoundIcon size={16} />
    </Button>
  )
}
